import { mapDTO } from '@twistezo/ts-dto-mapper'

import { commonGamSetupOrderFromDTO } from 'features/workspace/mappers/gamSetupOrderFromDTO'
import { GamSetupOrderSlice } from '../types'
import { GamSetupOrderSliceDTO } from './types'

type From = GamSetupOrderSliceDTO[]
type To = GamSetupOrderSlice[]

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    (dto: From): To => dto.map((order: GamSetupOrderSliceDTO) => commonGamSetupOrderFromDTO(order)),
  )
